import { Timer } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function DelayNode({ id, data, selected }) {
  const summary = data.duration ? `Wait ${data.duration} ${data.unit || 'seconds'}` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.logic}
      icon={Timer}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
